'use client'

import dynamic from 'next/dynamic'
import { useEffect, useState } from 'react'

import { usePathname } from '@/i18n/routing'
import { schedulePathAwareNonCriticalWork } from '@/lib/perf/scheduleNonCriticalWork'

const HomeAnchorScrollHandler = dynamic(() => import('./index'), { ssr: false })

export default function HomeAnchorScrollHandlerLazy() {
  const pathname = usePathname()
  const [shouldLoad, setShouldLoad] = useState(false)

  useEffect(() => {
    return schedulePathAwareNonCriticalWork(pathname, () => {
      setShouldLoad(true)
    })
  }, [pathname])

  if (!shouldLoad) {
    return null
  }

  return <HomeAnchorScrollHandler />
}
